import { AWFAction } from '@ansys-internal/awf-angular/core';
import { State } from '@ansys-internal/awf-angular/store';
import {
  PageState,
  PageStateExecuteEnum,
  PageStateInput,
  PageStateModel,
} from '../state/lib/app-page.state';

@AWFAction()
export class PageStateAction {
  constructor(private state: State) {}

  async execute(input: PageStateInput): Promise<PageStateInput> {
    const current = this.state.value(PageState);

    switch (input.type) {
      case PageStateExecuteEnum.SET_SECTION:
        this.state.set(PageState, {
          ...current,
          section: input.section,
        });
        break;

      case PageStateExecuteEnum.SET_SUBSECTION:
        this.state.set(PageState, {
          ...current,
          subsection: input.subsection,
        });
        break;

      case PageStateExecuteEnum.SET_RESULT_ID:
        this.state.set(PageState, {
          ...current,
          resultId: input.resultId,
        });
        break;

      case PageStateExecuteEnum.SET_COMPARISON_TOOL_JOB_IDS:
        this.state.set(PageState, {
          ...current,
          comparisonToolJobIds: input.comparisonToolJobIds,
        });
        break;
    }

    return input;
  }
}
